import { Modal } from 'bootstrap';
import Swiper from 'swiper';

import { Navigation, Thumbs } from 'swiper/modules';

/**
	* ProductOverviewGalleries
	* 
	* class to manage ProductOverviewGallery instance(s)
	*
	* TODOS:
	*   consider preloading grid zoom and modal hero images
	*/
export class ProductOverviewGalleries {
	constructor() {
		this.init = false;
		this.galleries = [];
	}

	setup() {
		if (this.init) return;

		this.init = true;

		const els = document.querySelectorAll('.product-overview-gallery');

		let i, gallery;

		for (i = 0; i < els.length; i++) {

			gallery = new ProductOverviewGallery(els[i]);

			this.galleries.push(gallery);
		}
	}
}

/**
	* ProductOverviewGallery
	* 
	* class to handle single Product Overview Gallery block
	*
	* @param el NodeElement the dom block container 
	*/
class ProductOverviewGallery {
	constructor(el) {
		console.log('ProductOverviewGallery', el);

		this.el = el;

		this.dom = {
			el,
			grid: el.querySelector('.product-overview-gallery__grid'),
			gridHero: el.querySelector('.product-overview-gallery__grid-image.hero'),
			gridThumbs: el.querySelectorAll('.product-overview-gallery__grid-image.thumbnail'),
			modal: el.parentNode.querySelector('.product-overview-gallery__modal'),
		};

		this.modalGallery = null;

		//console.log(this.dom);

		if (this.dom.grid && this.dom.gridHero && this.dom.gridThumbs.length) {

			this.initGridHover();

			if (this.dom.modal) {

				// this.dom.modal.addEventListener('show.bs.modal', () => {
				// 	return false;
				// });

				this.dom.modal.addEventListener('shown.bs.modal', this.onModalShown.bind(this));

				this.modalGallery = new ModalGallery(this.dom.modal);

				document.body.appendChild(this.dom.modal);
			}
		}
	}

	initGridHover() {

		let i, thumb;

		for (i = 0; i < this.dom.gridThumbs.length; i++) {

			thumb = this.dom.gridThumbs[i];

			thumb.addEventListener('mouseover', this.gridThumbHover.bind(this));
		}
	}

	/**
	 * handle grid thumb mouseover
	 *    set grid hero image
	 *    set grid hero slide index
	 * 
	 * @param {EventObject} evt 
	 */
	gridThumbHover(evt) {
		console.log('gridThumbHover', evt.currentTarget);

		const thumb = evt.currentTarget;
		const zoomSrc = thumb.dataset.zoomSrc;
		const heroImage = this.dom.gridHero.querySelector('img');

		this.dom.gridHero.dataset.slideIndex = thumb.dataset.slideIndex;

		heroImage.src = zoomSrc;
	}

	/**
	 * handle bootstrap modal shown event
	 * 
	 * @param {EventObject} evt 
	 * @returns 
	 */
	onModalShown(evt) {
		console.log('onModalShown', evt.relatedTarget);

		if (!this.modalGallery) {
			this.modalGallery = new ModalGallery(this.dom.modal);
		}

		if (!evt.relatedTarget || !this.modalGallery) return;

		const slideIndex = parseInt(evt.relatedTarget.dataset.slideIndex, 10);

		this.modalGallery.slideTo(slideIndex);
	}
}

class ModalGallery {
	constructor(el) {

		this.el = el;

		console.log('ModalGallery', this.el);

		this.thumbsSwiper = new Swiper(this.el.querySelector('.swiper.thumbs'), {
			modules: [Navigation],
			watchSlidesProgress: true,
			navigation: {
				nextEl: this.el.querySelector(".swiper.thumbs ~ .swiper-button-next"),
				prevEl: this.el.querySelector(".swiper.thumbs ~ .swiper-button-prev"),
			},
			centerInsufficientSlides: true,
			spaceBetween: 10,
			slidesPerView: 3,
			freeMode: true,
			breakpoints: {
				768: {
					slidesPerView: 4
				},
				1024: {
					slidesPerView: 5
				},
				//1200: {},
				1366: {
					slidesPerView: 6
				}
			}
		});

		this.heroesSwiper = new Swiper(this.el.querySelector('.swiper.heroes'), {
			modules: [Navigation, Thumbs],
			spaceBetween: 10,
			navigation: {
				nextEl: this.el.querySelector(".swiper.heroes .swiper-button-next"),
				prevEl: this.el.querySelector(".swiper.heroes .swiper-button-prev"),
			},
			thumbs: {
				swiper: this.thumbsSwiper,
			},
		});
	}

	slideTo(idx) {
		this.heroesSwiper.slideTo(idx);
	}
}